import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';

import { EmailReviewDialog } from '../email-review-dialog/email-review-dialog';
import { EmailReviewDialogService } from '../../services/email-review-dialog.service';

/** App-root host for the email-review pop-out dialog. Lives in app.html
 *  so any surface (rail / chat system-event card / future inline cards)
 *  can call EmailReviewDialogService.open() and get the same modal. */
@Component({
    selector: 'app-email-review-dialog-host',
    standalone: true,
    imports: [EmailReviewDialog],
    template: `
        @if (state(); as s) {
            <app-email-review-dialog
                [card]="s.card"
                [item]="s.item"
                [rowIndex]="s.rowIndex"
                [sectionLabel]="s.sectionLabel"
                (closed)="onClose()" />
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EmailReviewDialogHost {
    private readonly svc = inject(EmailReviewDialogService);
    readonly state = this.svc.current;

    onClose(): void {
        this.svc.close();
    }
}
